import {AxiosInstance, AxiosResponse} from "axios";
import {APIBase} from "../AxiosApiInstance";
import ApiRecommendationForRecommenderModel from "./ApiRecommendationForRecommenderModel";

export const ApiRecommendationForRecommenderPatch: (id:string, axios: AxiosInstance, payload: ApiRecommendationForRecommenderModel) => Promise<AxiosResponse<ApiRecommendationForRecommenderModel>> = (id, axios,payload) => {
  return axios.patch(`${APIBase}recommendations_for_recommender/${id}/`, payload);
};